import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import isAuthenticated from '../../utils/isAuthenticated';
import Authenticated from '../Authenticated';
import Home from '../Home';
import Register from '../Register';
import PasswordForgot from '../PasswordForgot';
import PasswordReset from '../PasswordReset';

import './App.css';

class App extends Component {
  render() {
    if (isAuthenticated()) {
      return <Authenticated />;
    }

    return (
      <Switch>
        <Route exact path="/registreer" component={Register} />
        <Route exact path="/wachtwoord/email" component={PasswordForgot} />
        <Route exact path="/wachtwoord/reset/:token" component={PasswordReset} />
        <Route component={Home} />
      </Switch>
    );
  }
}

export default App;
